import {
  getSalesManGeneralize,
  postCouponListFromDetail,
  postGeneralizeCustom,
} from '@/utils/http/modules/course/course.request'
import { getHadGotCouponList } from '@/utils/http/modules/camp/camp.request'
import { isPCBrowser } from '@/utils/utils'

export const AidToolMixin = {
  data() {
    return {
      showShareLogo: false, // 是否显示分销logo
      couponList: [], // 支付优惠券列表
      receiveCouponList: [], // 领取优惠券列表
      isShowBindPhone: false,
      showContent: false,
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.query.id)
    },
    zbid() {
      return window.zbvd.zbid || this.$route.query.zbid
    },
    shareuid() {
      return this.$route.query.shareuid
    },
  },
  methods: {
    /**
     * @description 是否开启推广
     * @param type 【7=课程】【9=专栏】
     */
    async WxSalesMan(type) {
      this.relateGeneralizeCustom()
      let params = {
        zbId: this.zbid,
        itemId: this.id,
        type,
      }
      try {
        const res = await getSalesManGeneralize(params)
        if (res.isok) {
          if (res.dataObj && res.dataObj.isShare) {
            this.showShareLogo = true
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 绑定客户关系
    async relateGeneralizeCustom() {
      if (!this.shareuid) return
      let params = {
        zbid: this.zbid,
        UserId: window.userInfo.id,
        SalesmanUserId: this.shareuid,
      }
      try {
        await postGeneralizeCustom(params)
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * @description 获取优惠券列表
     * @param type 【12=课程】【14=专栏】
     */
    async getCouponList(type) {
      let params = {
        zbId: this.zbid,
        relationId: this.id,
        type,
      }
      try {
        const data = await postCouponListFromDetail(params)
        this.receiveCouponList = data.dataObj || []
      } catch (e) {
        e && this.$toast(e)
      }
    },
    /**
     * @description 判断是否有优惠券
     * @param type 【12=课程】
     */
    async handleImmediatelyPay(type) {
      let params = {
        zbId: window.zbvd.zbid,
        relationId: this.id,
        type,
      }
      try {
        const res = await getHadGotCouponList(params)
        if (res.isok) {
          this.couponList = res.dataObj || []
          if (this.couponList.length) {
            this.handleClick()
          } else {
            this.handleGoToPay()
          }
        }
      } catch (e) {
        e && this.$toast(e)
      }
    },
    handleClick() {
      this.$refs.coupon.showModel(this.couponList)
    },
    onBindPhoneSuccess() {
      window.location.reload()
    },
    couponPay(id) {
      this.$refs.coupon.close()
      this.handleGoToPay(id)
    },
    paySuccess() {
      this.$toast.success('支付成功！')
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    },
    setHeight() {
      this.$nextTick(() => {
        let screenWidth = document.body.clientWidth || document.body.offsetWidth
        if (isPCBrowser()) {
          $('.img').css('height', `2.11rem`)
          this.app = 1
        } else {
          $('.img').css('height', `${(screenWidth * 9) / 16}px`)
        }
      })
    },
  },
}

export const TRAIN_VALUE = Object.freeze({
  SPECIAL: 5,
  CAMP: 6,
  COURSE: 4,
  IMAGETEXT: 3,
  AUDIO: 0,
  VIDEO: 1,
})
